export default __webpack_public_path__ + "static/media/thumbnail.9efeec9b.png";